import { render, staticRenderFns } from "./BodyDeContasAReceber.vue?vue&type=template&id=1eadb86a&scoped=true"
import script from "./BodyDeContasAReceber.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeContasAReceber.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeContasAReceber.vue?vue&type=style&index=0&id=1eadb86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eadb86a",
  null
  
)

export default component.exports